import { render } from "./ShareDataset.vue?vue&type=template&id=5a45fc5f"
import script from "./ShareDataset.vue?vue&type=script&lang=js"
export * from "./ShareDataset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__